import { applyMiddleware } from 'redux';
import { legacy_createStore as createStore } from 'redux'
import { combineReducers } from 'redux';
import settingsReducer from './reducer';
import settingsMiddleware from './middleware'
import { SettingState } from './actions';
import { persistedState, saveState } from './persisted.store';

export interface ApplicationState {
    settings: SettingState,
}

const middlewares = [
    settingsMiddleware
]

const reducers = combineReducers({
    settings: settingsReducer,
});

export function configureStore() {

    const store = createStore(
        reducers,
        persistedState, // second argument overrides the initial state
        applyMiddleware(
            ...middlewares
        )
    );

    // add a listener that will be invoked on any state change
    store.subscribe(() => {
        saveState(store.getState());
    });

    return store;
}